import { Component, Compiler,OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { LocalStorage } from '../services/local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../services/shared.service';
import { MessageService } from '../services/sharedName.service';
import {User} from '../models/user';
import { LoaderService } from '../services/Spinner.service';
import {IndexedDBService} from '.././services/indexdb.service';
// import {socketservice} from '../services/socket.service';

import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupLogComponent } from '../advertiser/popup/popup-log.component';
import { Subscription } from 'rxjs/Subscription';

// declare var OneSignal: any;
@Component({
  selector: 'app-header-account',
  templateUrl: './headermenuAccount.component.html',
  providers: [LocalStorage,SharedService, IndexedDBService,PopupLogComponent, MessageService],
  inputs: [`uservaluesearch`]
})
export class HeaderMenuAccountComponent implements OnInit {
  zizcard= [];
  user = new User();
  token:string;
  key: string;
  subscription: Subscription;
  message: any;
  uservaluesearch: string;
  searchShowFlag : boolean = false;
  constructor(private localstorage : LocalStorage,private router: Router, private route: ActivatedRoute, private shareService :SharedService, private loaderService : LoaderService, public indexedDB: IndexedDBService,private PopupSignup: PopupLogComponent, private dialogService:DialogService, private _compiler: Compiler, private messageService: MessageService, private ref: ChangeDetectorRef) {
    this.message="";
    // this.subscription = this.messageService.getMessage().subscribe(message => {     
    //   this.message = message;
    //   console.log(this.message)
    //   this.ref.detectChanges();
    //  }
    //  );
  }

  ngOnInit() {
     this.loaderService.loaderStatus.subscribe((val: boolean) => {
            this.user.objLoaderStatus = val;
        });
      

      // this.changeStatus("Account")
    //   this.subscription = this.messageService.getMessage().subscribe(message => { 
    //   this.message = message;
    //   console.log(this.message)
    //   this.ref.detectChanges();
    //  }
    //  );
  }


  showConfirm() {
            let disposable = this.dialogService.addDialog(PopupLogComponent, {
                title:'Logout', 
                message:'Are you sure you want to logout?'})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    if(isConfirmed) {
                    this.loaderService.displayLoader(true);
                 
                    var token=this.localstorage.getStorage('token');
                    this.shareService.clearIndexDb();
                      this.shareService.callApiWithToken("user/profile/logout",null,token).subscribe((result) => {
                            // var OneSignal = window["OneSignal"] || []; 
                            // OneSignal.push(function() {
                            // OneSignal.deleteTag('userID');
                            //     });
                            this.localstorage.removeStorage('token');
                            this.localstorage.removeStorage('userdata');
                            this.localstorage.removeStorage('selectedSegements');
                            this.localstorage.removeStorage('usertype');
                            this.localstorage.removeStorage('userID');
                            localStorage.removeItem('latitude1');
                            localStorage.removeItem('longitutde1');
                            this.localstorage.removeStorage('compaignId');
                            this.localstorage.removeStorage('groupnotificationstatus');
                            this.localstorage.removeStorage('disablenotificationID');
         
                            this.loaderService.displayLoader(false);
                            this.router.navigate(['users/login']); 
                             //window.location.reload();
                             this._compiler.clearCache();
                      });

                    }
                    else {
                        console.log('declined');
                        
                    }
                });
            //We can close dialog calling disposable.unsubscribe();
            //If dialog was not closed manually close it by timeout
        }

  logout() {
   
  this.showConfirm();

  }
 methodInsideYourComponent(value: string) { 
    if(value) {
       //window.location.reload();
       //this.uservaluesearch = value
       //this.messageService.sendMessage(value)
       this.router.navigate(['users/wall/'+value]);  
       
    }
  }
  redirectpage() {
     var token=this.localstorage.getStorage('token');
        var userType = this.localstorage.getStorage('usertype');
console.log(token);
console.log(userType);
     if(token && userType == 1) {
    this.router.navigate(['users/wall/']); 
     }
     else {
       this.router.navigate(['users/login']); 
     } 
  }
}



// WEBPACK FOOTER //
// ./src/app/common/headermenuAccount.component.ts